module.exports = __webpack_public_path__ + "img/icon-export-ppt.4bc69f08.svg";